// @ts-nocheck


import { useEffect, useState } from 'react';
import Modal from '../../../components/common/Modal';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { createTeamsPayload } from '../../location/locationTypes';
import { toast } from 'sonner';
import { createLocation, fetchCityList, fetchCountryList, fetchLocationList, fetchStateList, updateLocation } from '../../location/locationSlice';
import SearchDropdown from '../../../components/common/SearchDropdown';

interface BoardPageProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  editBoardData?: any;
  baseId: number;
  setEditBoardData: (value: any) => void;
  countryList: any[];
  setCountry: (country: any) => void;

}

interface LoadingStates {
  countries: boolean;
  states: boolean;
  city: boolean;
  submit: boolean;
}

// Utility function to format location string
const formatLocationString = (locationName: string): string => {
  if (!locationName) return '';
  
  // Split the string by commas
  const parts = locationName.split(',').map(part => part.trim());
  
  // If we have at least city and country (2 or more parts)
  if (parts.length >= 2) {
    const city = parts[0];
    const country = parts[parts.length - 1];
    return `${city}, ${country}`;
  }
  
  return locationName; // Return original if format doesn't match
};



const CreateBaseLocation: React.FC<BoardPageProps> = ({ isModalOpen, setIsModalOpen, editBoardData, baseId, setEditBoardData, setCountry }) => {


  const [name, setName] = useState('');
  const [purpose, setPurpose] = useState('');
  const [pincode, setPincode] = useState('')
  const [loadingLocation, setLoadingLocation] = useState(false);
  const dispatch = useAppDispatch();
  const [countryList, setCountryList] = useState<any[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [stateList, setStateList] = useState<any[]>([]);
  const [selectedState, setSelectedState] = useState<any>(null);
  const [cityList, setCityList] = useState<any[]>([]);
  const [selectedCity, setSelectedCity] = useState<any>(null);
  const [loadingStates, setLoadingStates] = useState<LoadingStates>({
    countries: false,
    states: false,
    city: false,
    submit: false
  });
  const [baseTeamsData, setBaseTeamsData] = useState<any[]>([]);
  const locations = useAppSelector((state) => state.location.locationDetails
  );
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (editBoardData) {
      // Set basic form fields
      setName(editBoardData.location_name || '');
      setPurpose(editBoardData.location_address || '');
      setPincode(editBoardData.location_pincode || '');
      if (editBoardData.location_city && editBoardData.location_state && editBoardData.location_country) {
        const formattedLocation = {
          locations_id: editBoardData.locations_id,
          locationName: `${editBoardData.location_city}, ${editBoardData.location_state}, ${editBoardData.location_country}`
        };
        setSelectedCountry(formattedLocation);
      }



      // // Load location data
      // const loadLocationData = async () => {
      //   // First, fetch countries and set selected country
      //   const countriesResponse = await dispatch(fetchCountryList()).unwrap();
      //   if (countriesResponse?.data) {
      //     setCountryList(countriesResponse.data);
      //     const country = countriesResponse.data.find(
      //       (c: any) => c.name === editBoardData.location_country
      //     );
      //     if (country) {
      //       setSelectedCountry(country);

      //       // Then fetch states for the selected country
      //       const statesResponse = await dispatch(fetchStateList(country.id)).unwrap();
      //       if (statesResponse?.data) {
      //         setStateList(statesResponse.data);
      //         const state = statesResponse.data.find(
      //           (s: any) => s.name === editBoardData.location_state
      //         );
      //         if (state) {
      //           setSelectedState(state);

      //           // Finally fetch cities for the selected state
      //           const citiesResponse = await dispatch(fetchCityList(state.id)).unwrap();
      //           if (citiesResponse?.data) {
      //             setCityList(citiesResponse.data);
      //             const city = citiesResponse.data.find(
      //               (c: any) => c.name === editBoardData.location_city
      //             );
      //             if (city) {
      //               setSelectedCity(city);
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }
      // };

      // loadLocationData();
    }
  }, [editBoardData, dispatch]);

  useEffect(() => {
    if (selectedCountry?.locationName) {
      // Format and set the name when country is selected
      const formattedLocation = formatLocationString(selectedCountry.locationName);
      setName(formattedLocation);
    }
  }, [selectedCountry]);


  useEffect(() => {
    const storedData = localStorage.getItem('baseTeamsData');
    if (storedData) {
      setBaseTeamsData(JSON.parse(storedData));
    }
  }, []);



  const handleSave = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    // Check if name, purpose, country, state, and city are filled in
    if (name.trim().length === 0) {
      setLoading(false);
      toast.error('Name is required.');
      return;
      // }
      //  else if (purpose.trim().length === 0) {
      //     setLoading(false);
      //     toast.error('Address is required.');
      //     return;
    } else if (!selectedCountry) {
      setLoading(false);
      toast.error('Country is required.');
      return;
    }
    // else if (!selectedState) {
    //   setLoading(false);
    //   toast.error('State is required.');
    //   return;
    // } 
    // else if (!selectedCity) {
    //   setLoading(false);
    //   toast.error('City is required.');
    //   return;
    // }

    const payload: createTeamsPayload = {
      base_id: baseId,
      location_name: name,
      // location_address: purpose,
      // location_city: selectedCity?.name,
      // location_state: selectedState?.name,
      locations_id: selectedCountry?.locations_id,
      location_pincode: pincode,
      // location_geocode: `${selectedCity?.latitude},${selectedCity?.longitude}`,
      id: editBoardData?.id
    };

    try {
      if (editBoardData) {
        // Update existing team
        const response = await dispatch(updateLocation({
          payload,
          userId: baseId,
          id: editBoardData.id
        }));

        if (response.meta.requestStatus === 'fulfilled') {
          toast.success('Office location updated successfully!');
        } else {
          toast.error('Failed to update office location.');
        }
      } else {
        // Create new team
        const response = await dispatch(createLocation({ payload, userId: baseId }));
        if (response.meta.requestStatus === 'fulfilled') {
          toast.success('Office location created successfully!');
        } else {
          if (response.error) {
          
            const errorPayload = response.payload as any;
            const { status, data } = errorPayload;
            console.log(errorPayload,"errorPayload",status, data ,"response.error", response.error);
            if (status === 409 && data?.data?.error) {
              toast.error(data?.data?.error?.replace(/_/g, " ")); // Display the error message
            } else {
              toast.error('Failed to create office location.'); // General error message
            }
          }
        }
      }

      setIsModalOpen(false);
      resetForm();

      // Fetch updated list
      const baseResponse = await dispatch(fetchLocationList(baseId));
      if (baseResponse?.payload) {
        localStorage.setItem('baseLocationData', JSON.stringify(baseResponse.payload));
        window.dispatchEvent(new StorageEvent('storage', {
          key: 'baseLocationData',
          newValue: JSON.stringify(baseResponse.payload)
        }));
      }

    } catch (error) {
      console.error("Failed to save team:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setName("");
    setPurpose("");
    setPincode("");
    setEditBoardData(null);
    setSelectedCountry(null);
    setSelectedState(null);
    setSelectedCity(null);
    setStateList([]);
    setCityList([]);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'name') {
      setName(value);
    } else if (name === 'purpose') {
      setPurpose(value);
    } else if (name === 'pincode') {
      setPincode(value);
    }
  };


  // Fetch countries when modal opens
  // useEffect(() => {
  //   if (isModalOpen) {
  //     fetchCountries();
  //   }
  // }, [isModalOpen]);

  // const fetchCountries = async () => {
  //   try {
  //     setLoadingStates(prev => ({ ...prev, countries: true }));
  //     const response = await dispatch(fetchCountryList()).unwrap();
  //     if (response?.data) {
  //       setCountryList(response.data);
  //     } else {
  //       console.error("No countries found");
  //       setCountryList([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching countries:", error);
  //     setCountryList([]);
  //   } finally {
  //     setLoadingStates(prev => ({ ...prev, countries: false }));
  //   }
  // };


  const fetchStates = async (countryId: number) => {
    if (!countryId) return;
    try {
      setLoadingStates(prev => ({ ...prev, states: true }));
      const response = await dispatch(fetchStateList(countryId)).unwrap();
      if (response?.data) {
        setStateList(Array.isArray(response.data) ? response.data : []);
      } else {
        setStateList([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setStateList([]);
    } finally {
      setLoadingStates(prev => ({ ...prev, states: false }));
    }
  };


  const fetchCity = async (stateId: number) => {
    if (!stateId) return;
    try {
      setLoadingStates(prev => ({ ...prev, city: true }));
      const response = await dispatch(fetchCityList(stateId)).unwrap();
      if (response?.data) {
        setCityList(Array.isArray(response.data) ? response.data : []);
      } else {
        setCityList([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setCityList([]);
    } finally {
      setLoadingStates(prev => ({ ...prev, city: false }));
    }
  }


  const handleCountryChange = async (country: any) => {
    setSelectedCountry(country);
    // setSelectedState(null);
    // setStateList([]);
    // setCityList([]);
    // setSelectedCity(null)

    // if (country?.id) {
    //   await fetchStates(country.id);
    // }
  };

  const handleStateChange = (state: any) => {
    setSelectedState(state);
    setSelectedCity(null);
    setCityList([]);
    if (state?.id) {
      fetchCity(state.id);
    }
  };

  const handleCityChange = (city: any) => {
    setSelectedCity(city);
  };



  useEffect(() => {
    if (countryList.length > 0) {
      // setSelectedCountry(countryList[0]);
      fetchStates(countryList[0].id);
    }
  }, [countryList]);





  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => {
        setIsModalOpen(false);
        resetForm();
      }}
      title={editBoardData ? "Edit Location" : "Create Location"}
      onSave={handleSave}
      loading={loading}
    >
      <form action="#" onSubmit={handleSave} className="space-y-6 mt-5">
        <div className='flex flex-col gap-y-2'>
          <div className='flex flex-col gap-y-2 mt-1'>
            <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5">Office city</label>
            <div className="relative">
              <SearchDropdown
                items={locations}
                buttonText="Search by city, state, or country"
                onChange={handleCountryChange}
                selectedItem={selectedCountry}
                isLoading={loadingLocation}
              />
            </div>

          </div>
          <label className='wg-label  mt-2 inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5'>Location name 
            <span className='text-[#575859]'>
            (Publically visible)
            </span>
            </label>
          <div className="relative">
            <input
              id='name'
              name='name'
              type='text'
              value={name}
              onChange={handleInputChange}
              placeholder='Enter Name'
              className="flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)]
               transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-2 
               focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db]
                dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
            />
          </div>
          {/* <div className='flex flex-col gap-y-2 mt-1'>
            <label className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5'>Address</label>
            <input
              id="purpose"
              name='purpose'
              type='text'
              value={purpose}
              onChange={handleInputChange}
              placeholder="Address"
              className="w-full px-3 py-2 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
            />
          </div> */}

          {/* <div className='flex flex-col gap-y-2 mt-1'>
            <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5">State</label>
            <div className="relative">
              <SearchDropdown
                items={stateList}
                buttonText="Select a state"
                onChange={handleStateChange}
                selectedItem={selectedState}
                disabled={!selectedCountry || loadingStates.submit}
                isLoading={loadingStates.states}
              />
            </div>
          </div> */}

          {/* <div className='flex flex-col gap-y-2 mt-1'>
            <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5">City</label>
            <div className="relative">
              <SearchDropdown
                items={cityList}
                buttonText="Select a city"
                onChange={handleCityChange}
                selectedItem={selectedCity}
                disabled={!selectedState || loadingStates.submit}
                isLoading={loadingStates.city}
              />
            </div>
          </div> */}

          <div className='flex flex-col gap-y-2 mt-2'>
            <label className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5'>Pin Code
              <span className='text-[#575859]'>(Optional)</span>
              </label>
            <input
              id="pincode"
              name='pincode'
              type='text'
              value={pincode}
              onChange={handleInputChange}
              placeholder="Pin code"
    className="flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)]
               transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-2 
               focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db]
                dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default CreateBaseLocation;